module.exports = __webpack_public_path__ + "media/icons/instagram@2x-cd709ab7.png";